import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/platform", label: "Platform" },
  { to: "/sentry", label: "Sentry" },
  { to: "/observatory", label: "Observatory" },
  { to: "/compliance", label: "Compliance" },
  { to: "/pricing", label: "Pricing" },
  { to: "/docs", label: "Docs" },
  { to: "/sdk", label: "SDKs" },
  { to: "/blog", label: "Blog" },
];

export default function MarketingNav() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  return (
    <header data-testid="marketing-nav" className="sticky top-0 z-40 backdrop-blur-md bg-[#F7F4EF]/85 border-b border-[rgba(17,30,51,0.08)]">
      <div className="container-x flex items-center justify-between h-[68px]">
        <Logo variant="light" />
        <nav className="hidden md:flex items-center gap-1">
          {links.map(l => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className={`px-3 py-2 text-[14px] rounded-full transition ${loc.pathname === l.to ? "bg-[rgba(17,30,51,0.08)] text-navy font-semibold" : "text-navy/80 hover:bg-[rgba(17,30,51,0.05)]"}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-2">
          <Link to="/login" data-testid="nav-signin" className="text-navy/80 hover:text-navy px-3 py-2 text-[14px] font-medium">Sign in</Link>
          <Link to="/contact" data-testid="nav-book-demo" className="btn-primary text-[14px]">Book a demo</Link>
        </div>
        <button data-testid="nav-mobile-toggle" className="md:hidden p-2" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[rgba(17,30,51,0.08)] bg-[#F7F4EF]">
          <div className="container-x py-3 flex flex-col gap-1">
            {links.map(l => <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="py-2 text-navy">{l.label}</Link>)}
            <Link to="/login" className="py-2 text-navy" onClick={() => setOpen(false)}>Sign in</Link>
            <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary mt-2 justify-center">Book a demo</Link>
          </div>
        </div>
      )}
    </header>
  );
}
